// Two-letter initials for the user avatar badge (top bar, Aegis AI chat).
export const getUserInitials = (name) => {
    const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }

    if (parts.length === 1) {
        const single = parts[0];
        if (single.length === 1) {
            return `${single[0]}${single[0]}`.toUpperCase();
        }
        return `${single[0]}${single[single.length - 1]}`.toUpperCase();
    }

    return "NA";
};
